export default __webpack_public_path__ + "static/media/iconeCriticidadeAvaliacao.ab548f37.svg";